/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CalendarEventResponse } from '../models/calendar-event-response';
import { deleteFeV1EventsId } from '../fn/events/delete-fe-v-1-events-id';
import { DeleteFeV1EventsId$Params } from '../fn/events/delete-fe-v-1-events-id';
import { getFeV1EventsId$Json } from '../fn/events/get-fe-v-1-events-id-json';
import { GetFeV1EventsId$Json$Params } from '../fn/events/get-fe-v-1-events-id-json';
import { getFeV1EventsId$Plain } from '../fn/events/get-fe-v-1-events-id-plain';
import { GetFeV1EventsId$Plain$Params } from '../fn/events/get-fe-v-1-events-id-plain';
import { postFeV1Events$Json } from '../fn/events/post-fe-v-1-events-json';
import { PostFeV1Events$Json$Params } from '../fn/events/post-fe-v-1-events-json';
import { postFeV1Events$Plain } from '../fn/events/post-fe-v-1-events-plain';
import { PostFeV1Events$Plain$Params } from '../fn/events/post-fe-v-1-events-plain';
import { postFeV1EventsIdLock } from '../fn/events/post-fe-v-1-events-id-lock';
import { PostFeV1EventsIdLock$Params } from '../fn/events/post-fe-v-1-events-id-lock';
import { postFeV1EventsIdUnlock } from '../fn/events/post-fe-v-1-events-id-unlock';
import { PostFeV1EventsIdUnlock$Params } from '../fn/events/post-fe-v-1-events-id-unlock';
import { putFeV1EventsId$Json } from '../fn/events/put-fe-v-1-events-id-json';
import { PutFeV1EventsId$Json$Params } from '../fn/events/put-fe-v-1-events-id-json';
import { putFeV1EventsId$Plain } from '../fn/events/put-fe-v-1-events-id-plain';
import { PutFeV1EventsId$Plain$Params } from '../fn/events/put-fe-v-1-events-id-plain';

@Injectable({ providedIn: 'root' })
export class EventsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postFeV1Events()` */
  static readonly PostFeV1EventsPath = '/v1/events';

  /**
   * Creates a new event.
   *
   * Creates a new event.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1Events$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1Events$Plain$Response(params?: PostFeV1Events$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEventResponse>> {
    return postFeV1Events$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new event.
   *
   * Creates a new event.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1Events$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1Events$Plain(params?: PostFeV1Events$Plain$Params, context?: HttpContext): Observable<CalendarEventResponse> {
    return this.postFeV1Events$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CalendarEventResponse>): CalendarEventResponse => r.body)
    );
  }

  /**
   * Creates a new event.
   *
   * Creates a new event.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1Events$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1Events$Json$Response(params?: PostFeV1Events$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEventResponse>> {
    return postFeV1Events$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new event.
   *
   * Creates a new event.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1Events$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1Events$Json(params?: PostFeV1Events$Json$Params, context?: HttpContext): Observable<CalendarEventResponse> {
    return this.postFeV1Events$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CalendarEventResponse>): CalendarEventResponse => r.body)
    );
  }

  /** Path part for operation `getFeV1EventsId()` */
  static readonly GetFeV1EventsIdPath = '/v1/events/{id}';

  /**
   * Gets an event by its hashed ID.
   *
   * Gets an event by its hashed ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1EventsId$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1EventsId$Plain$Response(params: GetFeV1EventsId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEventResponse>> {
    return getFeV1EventsId$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets an event by its hashed ID.
   *
   * Gets an event by its hashed ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1EventsId$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1EventsId$Plain(params: GetFeV1EventsId$Plain$Params, context?: HttpContext): Observable<CalendarEventResponse> {
    return this.getFeV1EventsId$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CalendarEventResponse>): CalendarEventResponse => r.body)
    );
  }

  /**
   * Gets an event by its hashed ID.
   *
   * Gets an event by its hashed ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1EventsId$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1EventsId$Json$Response(params: GetFeV1EventsId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEventResponse>> {
    return getFeV1EventsId$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets an event by its hashed ID.
   *
   * Gets an event by its hashed ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1EventsId$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1EventsId$Json(params: GetFeV1EventsId$Json$Params, context?: HttpContext): Observable<CalendarEventResponse> {
    return this.getFeV1EventsId$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CalendarEventResponse>): CalendarEventResponse => r.body)
    );
  }

  /** Path part for operation `putFeV1EventsId()` */
  static readonly PutFeV1EventsIdPath = '/v1/events/{id}';

  /**
   * Updates an existing event.
   *
   * Updates an existing event.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putFeV1EventsId$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1EventsId$Plain$Response(params: PutFeV1EventsId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEventResponse>> {
    return putFeV1EventsId$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing event.
   *
   * Updates an existing event.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putFeV1EventsId$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1EventsId$Plain(params: PutFeV1EventsId$Plain$Params, context?: HttpContext): Observable<CalendarEventResponse> {
    return this.putFeV1EventsId$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CalendarEventResponse>): CalendarEventResponse => r.body)
    );
  }

  /**
   * Updates an existing event.
   *
   * Updates an existing event.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putFeV1EventsId$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1EventsId$Json$Response(params: PutFeV1EventsId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEventResponse>> {
    return putFeV1EventsId$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing event.
   *
   * Updates an existing event.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putFeV1EventsId$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1EventsId$Json(params: PutFeV1EventsId$Json$Params, context?: HttpContext): Observable<CalendarEventResponse> {
    return this.putFeV1EventsId$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CalendarEventResponse>): CalendarEventResponse => r.body)
    );
  }

  /** Path part for operation `deleteFeV1EventsId()` */
  static readonly DeleteFeV1EventsIdPath = '/v1/events/{id}';

  /**
   * Deletes an event.
   *
   * Deletes an event.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFeV1EventsId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFeV1EventsId$Response(params: DeleteFeV1EventsId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteFeV1EventsId(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an event.
   *
   * Deletes an event.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFeV1EventsId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFeV1EventsId(params: DeleteFeV1EventsId$Params, context?: HttpContext): Observable<void> {
    return this.deleteFeV1EventsId$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postFeV1EventsIdLock()` */
  static readonly PostFeV1EventsIdLockPath = '/v1/events/{id}/lock';

  /**
   * Locks an event to prevent modifications.
   *
   * Locks an event to prevent modifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1EventsIdLock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeV1EventsIdLock$Response(params: PostFeV1EventsIdLock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postFeV1EventsIdLock(this.http, this.rootUrl, params, context);
  }

  /**
   * Locks an event to prevent modifications.
   *
   * Locks an event to prevent modifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1EventsIdLock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeV1EventsIdLock(params: PostFeV1EventsIdLock$Params, context?: HttpContext): Observable<void> {
    return this.postFeV1EventsIdLock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postFeV1EventsIdUnlock()` */
  static readonly PostFeV1EventsIdUnlockPath = '/v1/events/{id}/unlock';

  /**
   * Unlocks an event to allow modifications.
   *
   * Unlocks an event to allow modifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1EventsIdUnlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeV1EventsIdUnlock$Response(params: PostFeV1EventsIdUnlock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postFeV1EventsIdUnlock(this.http, this.rootUrl, params, context);
  }

  /**
   * Unlocks an event to allow modifications.
   *
   * Unlocks an event to allow modifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1EventsIdUnlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeV1EventsIdUnlock(params: PostFeV1EventsIdUnlock$Params, context?: HttpContext): Observable<void> {
    return this.postFeV1EventsIdUnlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
